/*
 * @Author: dongdong.wu
 * @Date: 2020-07-14 09:36:03
 * @LastEditTime: 2021-02-26 17:29:09
 * @FilePath: \ncim_web\src\utils\http\loading.js
 * @Description: loading控制
 */
import { Loading } from 'element-ui';


let loading        //定义loading变量

function START() {    //使用Element loading-start 方法
    loading = Loading.service({
        lock: true,
        text: '加载中...',
        background: 'rgba(0, 0, 0, 0.7)'
    })
}
function END() {    //使用Element loading-close 方法
    loading.close()
}


export { START, END };
